import React from 'react';

import moment from 'moment';
import FieldDefault from '../../../../components/PDFPage/Inputs/Default';

import logoInterOdonto from '../../../../assets/logo1.png';
import logoNotredame from '../../../../assets/logo2.png';

import FieldChecks from '../../../../components/PDFPage/Inputs/CheckGroup';
import FooterPDF from '../../../../components/PDFPage/FooterPDF';

import CategoryTitle from '../../../../components/PDFPage/CategoryTitle';

import Check from '../../../../components/PDFPage/Inputs/Check';

import schemaDependent from '../Dependente/schema';

import { cloneObject, formatMoney, addMaskCnpj } from '../../../../utils';

import * as S from './styles';

function RAC({ form }) {
    const DATE_FORMAT = 'DD/M/YY';

    const { dataTitular, dataDependentes, flow } = form;

    const planOptions = cloneObject(dataTitular.healthPlan.options);

    const extraEmptyPlans = 4 - (planOptions.length % 4);

    // Preenche o array com os restante pra fechar multiplo de 4, para encaixar no layout dos planos
    for (let i = 0; i < extraEmptyPlans; i += 1) {
        planOptions.push({});
    }

    const dependentesList = cloneObject(dataDependentes);

    const extraDependents = 4 - dataDependentes.length;

    if (extraDependents > 0) {
        // Preenche o array com no minimo 4 dependentes
        for (let i = 0; i < extraDependents; i += 1) {
            dependentesList.push(schemaDependent);
        }
    }

    return (
        <>
            <S.Container>
                <S.Header>
                    <S.LogoGroup>
                        <S.Logo src={logoNotredame} />

                        <S.Divisor />

                        <S.Logo src={logoInterOdonto} />
                    </S.LogoGroup>

                    <S.NumMotion>
                        <label>Nº da Proposta de Adesão</label>
                        <span />
                    </S.NumMotion>
                </S.Header>

                <S.TitleBar>Relação de Atualização Cadastral - RAC PME</S.TitleBar>

                <S.Label>Notredame Intermédica Saúde S/A</S.Label>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: 138 }}
                        slots={8}
                        label="Matrícula"
                        value={dataTitular.functionalEnrollment.value}
                    />
                    <FieldDefault
                        style={{ width: 138 }}
                        slots={7}
                        label="Cód. da Empresa"
                        value={dataTitular.company.value}
                    />
                    <FieldDefault
                        style={{ width: 140 }}
                        slots={19}
                        label="Empresa"
                        value={dataTitular.company.lookup}
                    />
                    <FieldDefault
                        style={{ width: 138 }}
                        slots={19}
                        label="CNPJ"
                        value={addMaskCnpj(dataTitular.company.cnpj)}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldChecks
                        label="Inclusão"
                        options={[
                            { label: 'Titular', checked: flow === 'adicionar_titular' },
                            {
                                label: 'Dependente/Agregado',
                                checked:
                                    flow === 'selecionar_titular' ||
                                    (flow === 'adicionar_titular' && dataDependentes.length > 0),
                            },
                        ]}
                    />

                    <FieldDefault
                        label="Data de admissão"
                        value={
                            dataTitular.admissionDate.value &&
                            moment(dataTitular.admissionDate.value).format(DATE_FORMAT)
                        }
                    />

                    <FieldChecks
                        style={{ width: '100%' }}
                        label="Alteração / Solicitação"
                        options={[
                            { label: 'Nome', checked: false },
                            { label: 'Estado Civil', checked: false },
                            { label: 'Segunda via', checked: false },
                            { label: 'Data de nascimento', checked: false },
                            { label: 'Plano (vide contrato)', checked: false },
                            { label: 'Outros:__________', checked: false },
                        ]}
                    />
                </S.GroupFields>

                <CategoryTitle title="Linha de planos / acomodação" />

                <S.GroupChecksSingle>
                    {planOptions.map((plan) => (
                        <Check label={plan.nome} checked={plan.codigo === dataTitular.healthPlan.value} />
                    ))}
                </S.GroupChecksSingle>

                <CategoryTitle title="Titular" />

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '100%' }}
                        slots={54}
                        label="Nome do Titular"
                        value={dataTitular.fullName.value}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '113px' }} slots={14} label="CPF" value={dataTitular.cpf.value} />
                    <FieldDefault
                        style={{ width: '113px' }}
                        slots={15}
                        label="Cartão Nacional de Saúde (CNS)"
                        value={dataTitular.sus.value && dataTitular.sus.value.replace(/\s/g, '')}
                    />
                    <FieldDefault style={{ width: '113px' }} slots={9} label="RG" value="" />
                    <FieldDefault style={{ width: '35px' }} label="Sexo" value={dataTitular.gender.value} />
                    <FieldDefault style={{ width: '35px' }} label="EC*" value={dataTitular.civilState.value} />
                    <FieldDefault style={{ width: '35px' }} label="GP**" value="" />
                    <FieldDefault
                        style={{ width: '100px' }}
                        slots={6}
                        label="Dt Nascimento"
                        value={dataTitular.birth.value && moment(dataTitular.birth.value).format(DATE_FORMAT)}
                    />
                    <FieldDefault
                        label="Idade"
                        value={dataTitular.birth.value && moment().diff(dataTitular.birth.value, 'years')}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '100%' }}
                        slots={45}
                        label="Nome da Mãe do Titular (obrigatoriamente nome completo)"
                        value={dataTitular.motherName.value}
                    />
                    <FieldDefault
                        style={{ width: '120px' }}
                        label="Valor R$"
                        value={formatMoney(dataTitular.planPrice)}
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '70%' }} slots={40} label="Nome do Responsável" />
                    <FieldDefault style={{ width: '30%' }} slots={14} label="Nº do CPF" />
                </S.GroupFields>

                <CategoryTitle title="Dados dos dependentes/Agregados - (obrigatório nome completo e CPF para maiores de 18 anos)" />

                {dependentesList.map((dependente, index) => {
                    const numDependente = index + 1;

                    return (
                        <S.DependenteBlock index={numDependente}>
                            <S.DependenteIndex style={{ width: '3% ' }}>{numDependente}</S.DependenteIndex>
                            <section style={{ width: '97% ' }}>
                                <S.GroupFields>
                                    <FieldDefault
                                        style={{ width: '70%' }}
                                        slots={38}
                                        value={dependente.fullName.value}
                                        label="Nome do Dependente / Agregado (Obrigatoriamente nome completo)"
                                    />
                                    <FieldDefault
                                        style={{ width: '30%' }}
                                        slots={15}
                                        value={dependente.cpf.value}
                                        label="Nº do CPF do dependente"
                                    />
                                </S.GroupFields>

                                <S.GroupFields>
                                    <FieldDefault
                                        style={{ width: '125px' }}
                                        slots={15}
                                        label="Cartão Nacional de Saúde"
                                        value={dependente.sus.value && dependente.sus.value.replace(/\s/g, '')}
                                    />
                                    <FieldDefault
                                        style={{ width: '125px' }}
                                        slots={10}
                                        label="Declaração de Nascido Vivo"
                                        value={dependente.dn.value}
                                    />
                                    <FieldDefault
                                        style={{ minWidth: '25px' }}
                                        label="Sexo"
                                        value={dependente.gender.value}
                                    />
                                    <FieldDefault
                                        style={{ minWidth: '25px' }}
                                        label="EC*"
                                        value={dependente.civilState.value}
                                    />
                                    <FieldDefault
                                        style={{ minWidth: '25px' }}
                                        label="GP**"
                                        value={dependente.kinshipDegree.value}
                                    />
                                    <FieldDefault
                                        style={{ width: '100px' }}
                                        slots={6}
                                        label="Dt Nascimento"
                                        value={
                                            dependente.birth.value && moment(dependente.birth.value).format(DATE_FORMAT)
                                        }
                                    />
                                    <FieldDefault
                                        style={{ width: '80px' }}
                                        slots={2}
                                        label="Idade"
                                        value={
                                            dataTitular.birth.value && moment().diff(dependente.birth.value, 'years')
                                        }
                                    />
                                    <FieldDefault style={{ width: '100%' }} slots={12} label="Celular dependente" />
                                </S.GroupFields>

                                <S.GroupFields>
                                    <FieldDefault
                                        style={{ width: '100%' }}
                                        slots={43}
                                        value={dependente.motherName.value}
                                        label="Nome da Mãe do Dependente / Agregado (Obrigatoriamente nome completo)"
                                    />
                                    <FieldDefault
                                        style={{ width: '120px' }}
                                        label="Valor R$"
                                        value={dependente.planPrice}
                                    />
                                </S.GroupFields>
                            </section>
                        </S.DependenteBlock>
                    );
                })}

                <CategoryTitle title="Endereço residencial - (Preenchimento Obrigatório)" />

                <S.GroupFields>
                    <FieldDefault style={{ width: '20%' }} slots={9} label="CEP" value={dataTitular.cep.value} />
                    <FieldDefault
                        style={{ width: '80%' }}
                        slots={45}
                        value={dataTitular.address.value}
                        label="Endereço Residencial"
                    />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '15%' }}
                        slots={5}
                        label="Nº"
                        value={dataTitular.addressNumber.value}
                    />
                    <FieldDefault
                        style={{ width: '30%' }}
                        slots={25}
                        label="Complemento"
                        value={dataTitular.complement.value}
                    />
                    <FieldDefault style={{ width: '55%' }} slots={24} label="Bairro" value={dataTitular.hood.value} />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault style={{ width: '30%' }} slots={19} label="Cidade" value={dataTitular.city.lookup} />
                    <FieldDefault style={{ width: '5%' }} slots={2} label="UF" value={dataTitular.uf.value} />
                    <FieldDefault style={{ width: '15%' }} slots={11} label="Telefone" />
                    <FieldDefault style={{ width: '25%' }} slots={10} label="Fax" />
                    <FieldDefault style={{ width: '25%' }} slots={11} label="Telefone para recado" />
                </S.GroupFields>

                <S.GroupFields>
                    <FieldDefault
                        style={{ width: '40%' }}
                        slots={11}
                        label="Celular (preenchimento obrigatório)"
                        value={dataTitular.cellphone.value && dataTitular.cellphone.value.replace(/\W|\s/g, '')}
                    />
                    <FieldDefault style={{ width: '60%' }} slots={42} label="E-mail" value={dataTitular.email.value} />
                </S.GroupFields>

                <CategoryTitle title="Legenda" />

                <S.Legend>
                    <S.FirstLegend>
                        <S.LegendTitle>* EC - Estado Civil </S.LegendTitle>
                        <S.LegendSubTitle>
                            (1) Solteiro (2) Casado (3) Viúvo (4) Separado (5) Divorciado (6) Outros
                        </S.LegendSubTitle>
                    </S.FirstLegend>

                    <S.Divisor />

                    <S.SecondLegend>
                        <S.LegendTitle>**GP - Grau de Parentesco</S.LegendTitle>
                        <S.LegendSubTitle>
                            (1) Cônjuge (2) Companheiro(a) (3) Filhos (4) Filho agregado (maior) (5) Pai (6) Mãe (7)
                            Padrasto (8) Madrasta (9) Tio(as) (10) Sogro(a) (11) Irmãos(as) (12) Netos (13) Outros
                        </S.LegendSubTitle>
                    </S.SecondLegend>
                </S.Legend>

                <CategoryTitle title="Dados de reembolso" />

                <S.LegendTitle>
                    Autorizo a NotreDame Intermedíca a depositar, na conta-corrente por mim indicada abaixo os valores
                    de reembolso das despesas cobertas pela operadora, realizadas por mim ou por meu(s) dependente(s)/
                    agregados(s), cabendo a mim a responsabilidade de informar à operadora quaisquer alterações que
                    venham a ocorrer na conta indicada, observado o plano contratado.
                </S.LegendTitle>

                <S.GroupFields>
                    <FieldDefault style={{ minWidth: '100px' }} label="BANCO (CÓDIGO)" />
                    <FieldDefault style={{ minWidth: '155px' }} label="NOME DO BANCO" />
                    <FieldDefault style={{ minWidth: '100px' }} label="Nº DA AGÊNCIA" />
                    <FieldDefault style={{ minWidth: '100px' }} label="Nº DA CONTA-CORRENTE" />
                    <FieldDefault style={{ minWidth: '100px' }} label="DV" />
                </S.GroupFields>
            </S.Container>

            <FooterPDF />

            <S.Container>
                <S.Header>
                    <S.LogoGroup>
                        <S.Logo src={logoNotredame} />

                        <S.Divisor />

                        <S.Logo src={logoInterOdonto} />
                    </S.LogoGroup>

                    <S.NumMotion>
                        <label>Nº da Proposta de Adesão</label>
                        <span />
                    </S.NumMotion>
                </S.Header>

                <CategoryTitle title="Principais Condições da adesão (leia atentamente)" />

                <S.SpacingTextCustom>
                    <S.TextCustom>Pelo presente, declaro expressamente que:</S.TextCustom>
                    <S.TextCustom>
                        Ao preencher e assinar esta relação de atualização cadastral, recebi todas as informações sobre
                        meus direitos e obrigações inerentes ao plano de assistência à saúde contratado, em meu
                        benefício e de meus dependentes / agregados elegíveis.
                    </S.TextCustom>

                    <S.TextCustom>Estou ciente de que para empresas MEI não serão aceitos agregados.</S.TextCustom>

                    <S.TextCustom>
                        Estou ciente e de acordo que o plano de meus dependentes / agregados será sempre o mesmo que o
                        do titular.
                    </S.TextCustom>

                    <S.TextCustom>
                        Tenho ciência e estou de acordo com os prazos de carências estabelecidos no momento da
                        contratação, não tenho nenhuma dúvida quanto à sua aplicação.
                    </S.TextCustom>

                    <S.TextCustom>
                        Tenho ciência e estou de acordo que eventuais reduções ou isenções dos prazos de carência,
                        ocorridas em função de plano anterior, poderão ser aplicadas a todas ou apenas parte das
                        coberturas contratadas e que em nenhuma hipótese alteram as demais cláusulas contratuais.
                    </S.TextCustom>

                    <S.TextCustom>
                        Estou ciente de que deverei informar o número do CPF de meus dependentes / agregados maiores de
                        18 (dezoito) anos, não podendo utilizar meu número de CPF para efetiva inclusão dos mesmos no
                        plano.
                    </S.TextCustom>

                    <S.TextCustom>
                        (i) a Operadora poderá utilizar meus dados de contato registrados nesta Proposta, e as
                        atualizações que eu venha a fazer durante o período de vigência do meu contrato, para o envio de
                        avisos, notificações e comunicações relacionados ao benefício contratado.
                    </S.TextCustom>

                    <S.TextCustom>
                        (ii) que serão admitidas outras formas de assinatura para esta Proposta, desde que assegurem a
                        sua autenticidade e sejam legalmente permitidas. Aceito como válido o meio tecnológico adotado
                        para o aceite digital desta Proposta, conforme termos dos normativos vigentes.
                    </S.TextCustom>

                    <S.TextCustom>
                        (iii) que a Operadora poderá realizar a coleta, uso, armazenamento, tratamento e proteção dos
                        dados pessoais do beneficiário titular e se houver, do beneficiário dependente e/ou agregado,
                        incluindo, mas não se limitando: nome, endereço, CPF, profissão, telefone e e-mail, conforme
                        permitido pela legislação aplicável.
                    </S.TextCustom>

                    <S.TextCustom>
                        (iv) de que estes dados serão utilizados com o objetivo de atuar na viabilização,
                        comercialização e administração dos produtos de assistência médica e/ou odontológica, no
                        cumprimento de obrigações perante os órgãos reguladores, no atendimento à eventuais demandas
                        judiciais e/ou para outras finalidades descritas na Política de Privacidade do Grupo NotreDame
                        Intermédica. Para mais informações, acesse https://www.gndi.com.br/politicas-de-privacidade.
                    </S.TextCustom>

                    <S.TextCustom>
                        (iv) da obtenção de fotografia do tipo selfie no ato da contratação extraída por funcionalidade
                        do próprio sistema para fins de garantia da prevenção à fraude e à segurança do beneficiário
                        titular, nos processos de identificação e autenticação de cadastro em sistemas eletrônicos, que
                        poderá ser comparada às fotos dos documentos apresentados e comprovar a autenticidade desta
                        contratação.
                    </S.TextCustom>

                    <S.TextCustom>
                        Declaro que possuo absoluta capacidade jurídica para exercer livremente os meus atos civis.
                    </S.TextCustom>

                    <S.TextCustom>
                        Para todos os fins e efeitos, as informações por mim prestadas são verdadeiras e completas, sem
                        omissão de quaisquer circunstâncias que possam incluir na minha aceitação e de meus dependentes
                        / agregados.
                    </S.TextCustom>

                    <S.TextCustom>
                        A presente relação de atualização cadastral é parte integrante do contrato, o qual foi recebido,
                        integralmente lido, entendido e aceito pela minha empresa e por mim, sem quaisquer restrições ao
                        seu conteúdo, o que confirmo preenchendo e assinando.
                    </S.TextCustom>
                </S.SpacingTextCustom>

                <S.SpacingTextCustom />

                <S.GroupFields>
                    <FieldDefault style={{ width: '51%' }} label="Local e Data" />
                    <FieldDefault style={{ width: '51%' }} label="Assinatura do Titular ou Representante Legal" />
                </S.GroupFields>
            </S.Container>
        </>
    );
}

export default RAC;
